import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import PersonIcon from '@material-ui/icons/Person';

//import Modal from 'shared/components/Modal';
import Modal from 'app/components/Modal';
import modalStyles from 'shared/components/modalStyles';
import config from 'shared/config/config';
import messages, { FormattedMessage } from 'shared/messages/messages';
import { Person } from '@mui/icons-material';

import {
  createFamily,
  searchVisits,
  searchCustomers,
  addMergedStory,
  addVisit,
  removeVisit,
  getGuests,
  me,
  authorizePin
} from 'app/actions/kioskActions';

import {
  fetchStripeSettings
} from 'shared/actions/storyActions';

import {
  getMoments
} from 'shared/actions/cartActions';

import {
  CLUB_MED_LOGIN_TYPE,
  ACCESS_CODE_LOGIN_TYPE
} from 'app/utils/Constants';


const styles = () => ({
  button: {
    float: 'left',
    width: '100%',
    marginBottom: '0.5rem',
    textAlign: 'center',
    padding: '0.3rem 1rem',
    fontSize: '1rem',
    fontWeight: 600,
    background: 'linear-gradient(#ffffff, #f1f1f1)',
    border: '1px solid #dcdcdc',
    borderRadius: '3px',
    boxShadow: '0 0 2px #dcdcdc',
    color: '#2b8eb0',
    fontFamily: config.root_font_family
  },
  label: {
    float: 'left',
    fontWeight: 600,
    fontFamily: config.root_font_family
  },
  input: {
    width: '100%',
    fontSize: '1.1rem',
    padding: '0.7655rem',
    borderRadius: '5px',
    border: '1px solid #aaa',
    fontFamily: config.root_font_family
  },
  inputGroup: {
    padding: '0.3rem 0'
  },
  ...modalStyles()
});

const defaultFlags = {
  showVisit: false,
  showSearchResults: false,
  showConnectReader: false,
  stripe_reader_code: '',
  stripe_reader_label: '',
  stripe_reader_location_id: ''
}

class AdminDialog extends React.Component {
  constructor(props) {
    super(props);

    this.roomInput = createRef();
    this.searchInput = createRef();
    this.pinInput = createRef();
    this.readerCodeInput = createRef();
    this.readerLocationIdInput = createRef();
    this.readerLabelInput = createRef();

    this.state = {
      ...defaultFlags
    }
  }

  async showVisit(visit) {
    this.setState({
      ...defaultFlags,
      showVisit: true,
      visit
    });
  }

  async showConnectReader() {
    this.setState({
      ...defaultFlags,
      showConnectReader: !this.state.showConnectReader
    });
  }

  async showAddRoom() {
    this.setState({
      ...defaultFlags,
      showVisit: false
    });
  }

  async showCustomersResults(customers) {
    this.setState({
      ...defaultFlags,
      showCustomersResults: true,
      customers
    });
  }

  async showNoCustomersResults() {
    this.setState({
      ...defaultFlags,
      showCustomersResults: false
    });
  }

  async showSearchResults(visits) {
    this.setState({
      ...defaultFlags,
      showSearchResults: true,
      visits
    });
  }

  async showNoSearchResults() {
    this.setState({
      ...defaultFlags,
      showSearchResults: false
    });
  }

  authorizePin() {
    const { settings, authorizePin } = this.props;
    let pin = this.pinInput.current.value;

    return authorizePin(settings.account_id, pin)
      .catch(err => {
        console.error(err);
        throw 'Invalid pin';
      });
  }

  close() {
    this.props.close();
    setTimeout(() => this.back(), 500);
  }

  back() {
    this.setState(defaultFlags);
  }

  closeTab() {
    window.postMessage({ type: 'KIOSK', action: 'closeTab' }, '*');
    throw ""
  }

  async addMergedStory(storyId) {
    const { settings, user, addMergedStory, getMoments, me } = this.props;

    await addMergedStory(settings.token, user.story_id, storyId);

    // refresh the following
    await me(settings.token);
    await getMoments(settings.token, user.story_id);

    this.close();
  }

  searchCustomers() {
    const { settings, searchCustomers, user } = this.props;
    let search = this.searchInput.current.value;

    return searchCustomers(settings.token, user.customer_id, search)
      .then(customers => {
        if (customers && customers.length) {
          this.showCustomersResults(customers);
        } else {
          this.showNoCustomersResults();
        }

        return Promise.resolve();
      });
  }

  searchRoom() {
    const { settings, searchVisits } = this.props;
    let room = this.roomInput.current.value;

    return searchVisits(settings.token, room)
      .then(visits => {
        if (visits && visits.length) {
          this.showSearchResults(visits);
        } else {
          this.showNoSearchResults();
        }

        return Promise.resolve();
      });
  }

  async addVisit(visit) {
    const {
      settings,
      user,
      createFamily,
      addVisit,
      getGuests,
      getMoments,
      me
    } = this.props;

    if (!user.family_id) {
      let family = await createFamily(settings.token, user.story_id);
      await addVisit(settings.token, family.id, visit)
    } else {
      await addVisit(settings.token, user.family_id, visit)
    }

    // refresh the following
    await me(settings.token);
    await getGuests(settings.token, user.story_id);
    await getMoments(settings.token, user.story_id);

    //if (window.cartComponent) {
    //  window.cartComponent.refresh();
    //}

    this.close();
  }

  async removeVisit(visit) {
    const {
      settings,
      user,
      removeVisit,
      getGuests,
      getMoments
    } = this.props;

    await removeVisit(settings.token, user.family_id, visit);
    await getGuests(settings.token, user.story_id);
    await getMoments(settings.token, user.story_id);

    //if (window.cartComponent) {
    //  window.cartComponent.refresh();
    //}

    this.close();
  }

  onInputchange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  renderPinSlide() {
    const { classes } = this.props;

    let slide = {};

    slide.component = (
      <div>
        <div className={classes.modalHeader}>
          <span style={{ fontWeight: 600 }}>Enter PIN</span>
        </div>
        <hr />
        <div className={classes.inputGroup}>
          <label className={classes.label} style={{ marginBottom: '0.2rem' }} for="room">
            PIN
          </label>
          <input ref={this.pinInput} className={classes.input} type="password" name="pin" style={{ borderColor: '#aaa' }} />
        </div>
      </div>
    );

    slide.nextLabel = <FormattedMessage {...messages.button_approve} />;
    slide.onNext = () => this.authorizePin();
    slide.prevLabel = <FormattedMessage {...messages.button_back} />;

    return slide;
  }

  renderMenuSlide() {
    const { classes, settings, user } = this.props;
    let isViewPhotosMode = localStorage.getItem('VIEW_PHOTOS');
    let slide = {};

    slide.component = (
      <div className={classes.modalHeader}>
        <span style={{ fontWeight: 600 }}>System Menu</span>
      </div>
    );

    slide.buttons = [];

    if (settings.stripe_reader_enabled) {
      slide.buttons.push({
        finishLabel: 'CONNECT STRIPE READER',
        onFinish: () => this.showManageReaders(),
        skipClose: true
      });
    }

    slide.buttons.push({
      nextLabel: 'REFRESH',
      onNext: () => { window.location.reload(); throw "" }
    });

    if (user) {
      if (settings.login_type === CLUB_MED_LOGIN_TYPE) {
        slide.buttons.push({
          nextLabel: 'MANAGE ROOMS'
        });
      } else {
        slide.buttons.push({
          nextLabel: 'MERGE STORIES'
        });
      }
    }

    if (settings.pre_print) {
      slide.buttons.push({
        finishLabel: 'PRE-PRINT GALLERY - [' + (isViewPhotosMode === 'true' ? 'ON]' : 'OFF]'),
        onFinish: () => {
          localStorage.setItem('VIEW_PHOTOS', isViewPhotosMode === 'false' || !isViewPhotosMode ? 'true' : 'false');
          this.close();
          window.location.reload();
        }
      });
    }

    slide.buttons.push({
      nextLabel: 'CLOSE KIOSK',
      onNext: () => this.closeTab()
    });

    slide.onBackClose = true;

    return slide;
  }

  renderMergeStoriesSlide() {
    const { classes, user, mergedStories, settings } = this.props;
    let slide = {};

    if (!user) {
      return slide;
    }

    slide.component = (
      <div className={classes.modalHeader}>
        <span style={{ fontWeight: 600 }}>Merge Stories</span>
      </div>
    );

    slide.buttons = mergedStories.map(story => {
      return {
        finishLabel: (
          <span>
            <PersonIcon style={{ margin: '-0.2rem 0.1rem 0' }} />
            {settings.login_type === ACCESS_CODE_LOGIN_TYPE ? (
              <span style={{ fontWeight: 600 }}>{story.access_code}</span>
            ) : (
              <span style={{ fontWeight: 600 }}>{story.email}</span>
            )
            }
            <span style={{ fontWeight: 600 }}> - {story.name}</span>
          </span>
        ),
        onFinish: () => this.addMergedStory(story.source_story_id)
      };
    });

    slide.buttons.push({
      nextLabel: 'ADD CUSTOMER'
    });

    return slide;
  }

  renderAddCustomerSlide() {
    const { classes, settings } = this.props;

    let slide = {};

    slide.component = (
      <div>
        <div className={classes.modalHeader}>
          <span style={{ fontWeight: 600 }}>Add Customer</span>
        </div>
        <hr />
        <div className={classes.inputGroup}>
          <label className={classes.label} style={{ marginBottom: '0.2rem' }} for="search">
            {settings.login_type === ACCESS_CODE_LOGIN_TYPE ? 'Access Code' : 'Email'}
          </label>
          <input ref={this.searchInput} className={classes.input} type="text" name="search" style={{ borderColor: '#aaa' }} />
        </div>
      </div>
    );

    slide.nextLabel = 'SEARCH';
    slide.onNext = () => this.searchCustomers();

    return slide;
  }

  renderManageRoomsSlide() {
    const { classes, visits } = this.props;

    let slide = {};

    slide.component = (
      <div className={classes.modalHeader}>
        <span style={{ fontWeight: 600 }}>Manage Rooms</span>
      </div>
    );

    slide.buttons = [];

    for (let id of visits.allIds) {
      let visit = visits.byId[id];

      slide.buttons.push({
        nextLabel: (
          <span>
            <MeetingRoomIcon style={{ margin: '-0.2rem 0.1rem 0' }} />
            <span style={{ fontWeight: 600 }}>{visit.room}</span>
          </span>
        ),
        onNext: () => this.showVisit(visit)
      });
    }

    slide.buttons.push({
      nextLabel: 'ADD ROOM',
      onNext: () => this.showAddRoom()
    });

    return slide;
  }

  renderVisitSlide() {
    const { classes, user } = this.props;
    let { visit } = this.state;

    let slide = {};

    if (!user) {
      return slide;
    }

    if (!visit) {
      visit = {};
    }

    slide.component = (
      <div className={classes.modalHeader}>
        <span style={{ fontWeight: 600 }}>Room </span>
        <MeetingRoomIcon style={{ margin: '-0.2rem 0.1rem 0' }} />
        <span style={{ fontWeight: 600 }}>{visit.room}</span>
      </div>
    );

    slide.buttons = [];

    if (visit.room !== user.room) {
      slide.buttons.push({
        nextLabel: 'REMOVE',
        onNext: () => this.removeVisit(visit)
      });
    }

    return slide;
  }

  renderAddRoomSlide() {
    const { classes } = this.props;

    let slide = {};

    slide.component = (
      <div>
        <div className={classes.modalHeader}>
          <span style={{ fontWeight: 600 }}>Add Room</span>
        </div>
        <hr />
        <div className={classes.inputGroup}>
          <label className={classes.label} style={{ marginBottom: '0.2rem' }} for="room">
            Room
          </label>
          <input ref={this.roomInput} className={classes.input} type="text" name="room" style={{ borderColor: '#aaa' }} />
        </div>
      </div>
    );

    slide.nextLabel = 'SEARCH';
    slide.onNext = () => this.searchRoom();

    return slide;
  }

  renderSearchResultsSlide() {
    const { classes } = this.props;
    const { visits } = this.state;

    let slide = {};

    slide.component = (
      <div className={classes.modalHeader}>
        <span style={{ fontWeight: 600 }}>Select Reservation</span>
      </div>
    );

    slide.buttons = visits.map(visit => {
      let lastNames = {};
      for (let c of visit.customers) {
        lastNames[c.last_name] ||= [];
        lastNames[c.last_name].push(c.first_name);
      }

      let groups = [];
      for (let lastName in lastNames) {
        let firstNames = lastNames[lastName];
        let group = `${firstNames.join(', ')} ${lastName}`;
        groups.push(group);
      }

      let names = groups.join('; ');

      return {
        nextLabel: (
          <span>
            <MeetingRoomIcon style={{ margin: '-0.2rem 0.1rem 0' }} />
            <span style={{ fontWeight: 600 }}>{visit.room}: </span>
            <span style={{ fontWeight: 500 }}>{names}</span>
          </span>
        ),
        onNext: () => this.addVisit(visit)
      };
    });

    return slide;
  }

  renderCustomersResultsSlide() {
    const { classes, settings } = this.props;
    const { customers } = this.state;

    let slide = {};

    slide.component = (
      <div className={classes.modalHeader}>
        <span style={{ fontWeight: 600 }}>Select Customer</span>
      </div>
    );

    slide.buttons = customers.map(customer => {
      return {
        nextLabel: (
          <span>
            <Person style={{ margin: '-0.2rem 0.1rem 0' }} />
            {settings.login_type === ACCESS_CODE_LOGIN_TYPE ? (
              <span style={{ fontWeight: 600 }}>{customer.access_code}</span>
            ) : (
              <span style={{ fontWeight: 600 }}>{customer.email}</span>
            )
            }
            <span style={{ fontWeight: 500 }}> - {customer.name}</span>
          </span>
        ),
        onNext: () => this.addMergedStory(customer.story_id)
      };
    });

    return slide;
  }

  showManageReaders() {
    if (this.props.onShowStripeReaders) {
      this.props.onShowStripeReaders();
    }
  }

  renderNoSearchResultsSlide() {
    const { classes } = this.props;

    let slide = {};

    slide.component = (
      <div>
        <div className={classes.modalHeader}>
          <span style={{ fontWeight: 600 }}>No Results</span>
        </div>
        <hr />
        <p>No active reservations were found for this room.</p>
      </div>
    );

    return slide;
  }

  renderNoCustomersResultsSlide() {
    const { classes } = this.props;

    let slide = {};

    slide.component = (
      <div>
        <div className={classes.modalHeader}>
          <span style={{ fontWeight: 600 }}>No Results</span>
        </div>
        <hr />
        <p>No customers found.</p>
      </div>
    );

    return slide;
  }

  render() {
    const { settings } = this.props;

    const {
      showVisit,
      showSearchResults,
      showCustomersResults,
      showConnectReader
    } = this.state;

    let slides = [];
    slides.push(this.renderPinSlide());
    slides.push(this.renderMenuSlide());

    if (settings.login_type === CLUB_MED_LOGIN_TYPE) {
      slides.push(this.renderManageRoomsSlide());

      if (showVisit) {
        slides.push(this.renderVisitSlide());
      } else {
        slides.push(this.renderAddRoomSlide());
      }

      if (showSearchResults) {
        slides.push(this.renderSearchResultsSlide());
      } else {
        slides.push(this.renderNoSearchResultsSlide());
      }
    } else {
      slides.push(this.renderMergeStoriesSlide());
      slides.push(this.renderAddCustomerSlide());

      if (showCustomersResults) {
        slides.push(this.renderCustomersResultsSlide());
      } else {
        slides.push(this.renderNoCustomersResultsSlide());
      }
    }

    return <Modal slides={slides} open={this.props.isOpen} onClose={() => this.close()} />;
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  user: state.kioskReducer.user,
  guests: state.kioskReducer.guests,
  visits: state.kioskReducer.visits,
  mergedStories: state.kioskReducer.mergedStories,
});

export default connect(mapStateToProps, { fetchStripeSettings, createFamily, searchVisits, searchCustomers, addMergedStory, addVisit, removeVisit, getGuests, getMoments, me, authorizePin })(withStyles(styles)(AdminDialog));
